import { useState, useEffect } from "react";
import {
  FaCog,
  FaUsers,
  FaBox,
  FaShoppingCart,
  FaClipboardList,
  FaChartPie,
  FaBook,FaPlus,
  FaDoorOpen,FaCar,FaSearch,FaBiohazard,FaFistRaised
} from "react-icons/fa";
import { MdQrCodeScanner } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";


  // Mets à jour filteredMenu à chaque rendu
  // const menuItems = [
  //   {
  //     name: "GESTION DES VEHICULES",
  //     icon: <FaCar />,
  //     color: "bg-gray-100",
  //     page: "/menuvehicule",
  //     roles: ["enregistreur", "admin", "admin_police", "admin_gendarmerie", "transport", "admin_douane", "controleur"]
  //   },
  //   {
  //     name: "POSTES DE CONTRÔLE",
  //     icon: <MdQrCodeScanner />,
  //     color: "bg-gray-100",
  //     page: "/menucheckpoint",
  //     roles: ["admin_police", "admin_gendarmerie", "admin", "transport", "admin_douane"]
  //   },
  //   {
  //     name: "STATISTIQUES ET RAPPORTS",
  //     icon: <FaChartPie />,
  //     color: "bg-gray-100",
  //     page: "/statistiques",
  //     roles: ["admin", "transport", "admin_douane"]
  //   },
  //   {
  //     name: "GESTION DES UTILISATEURS",
  //     icon: <FaUser />,color: "bg-gray-100",
  //     page: "/users",
  //     roles: ["admin", "admin_douane", "admin_police", "admin_gendarmerie"]
  //   },
  //   {
  //     name: "DÉCONNECTER",
  //     icon: <FaDoorOpen />,
  //     color: "bg-red-100",
  //     page: "/",
  //     roles: ["admin", "admin_police", "admin_gendarmerie", "enregistreur", "transport", "admin_douane"]
  //   },
  // ];



export default function MenuVehicule() {

  const userStatu = localStorage.getItem("statu");
  const [statu, setStatu] = useState(localStorage.getItem("statu"));

    // Ajoute ce useEffect pour écouter les changements de localStorage
    useEffect(() => {
      const onStorage = () => setStatu(localStorage.getItem("statu"));
      window.addEventListener("storage", onStorage);
      return () => window.removeEventListener("storage", onStorage);
    }, []);
    const menuItems = [
      { name: "Recherche", icon: <FaSearch />, color: "bg-gray-100", page: "../vehiculepage",  roles: ["admin", "admin_police", "admin_gendarmerie", "transport", "admin_douane", "controleur"]
      },

      { name: "Ajouter", icon: <FaPlus />, color: "bg-gray-100", page: "../ajoutvoiture",  roles: ["enregistreur"]
      }
    ];
    const filteredMenu = menuItems.filter((item) => item.roles.includes(statu));

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full max-w-screen-xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 pt-28 pb-8 text-black">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
        {filteredMenu.map((item, index) => (
          <Link to={item.page} key={index} className="transition hover:scale-[1.02]">
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.35, delay: index * 0.06 }}
              className={`w-full h-28 sm:h-32 md:h-36 px-4 sm:px-6 py-4 flex flex-col items-center justify-center rounded-xl shadow-lg cursor-pointer ${item.color}`}
            >
              <div className="text-2xl sm:text-3xl">{item.icon}</div>
              <span className="mt-2 text-center text-xs sm:text-sm md:text-base font-semibold uppercase">
                {item.name}
              </span>
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  );
}
